import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Features, Flag } from './Feature';
import { DEFAULT_FEATURE_FLAGS } from '../../../config';

interface FeatureFlagsState {
  flags: Partial<Features>;
}

const initialState: FeatureFlagsState = {
  flags: DEFAULT_FEATURE_FLAGS,
};

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setFeatureFlag<F extends Flag>(
      state: FeatureFlagsState,
      action: PayloadAction<{ flag: F; value: Features[F] }>,
    ) {
      state.flags[action.payload.flag] = action.payload.value;
    },
    setAllFlags(state: FeatureFlagsState, action: PayloadAction<Partial<Features>>) {
      state.flags = {
        ...state.flags,
        ...action.payload,
      };
    },
  },
});

export const { setFeatureFlag, setAllFlags } = featureFlagsSlice.actions;
export default featureFlagsSlice.reducer;
